import React from 'react';
import { calendarEventApi } from '../../../services/apis';
import momentjs from 'moment-jalaali';
import moment from 'moment-hijri';

const setValue = (value) => {
  return {
    value,
    writable: true,
    enumerable: false,
    configurable: true,
  };
};

const DATE_FORMAT_MOMENT = 'M/D/YYYY';
const Utility = Object.create(null, {
  Overlay: setValue(function Overlay({ show, callback }) {
    if (show)
      return (
        <div
          onClick={callback}
          style={{
            zIndex: 10,
            position: 'fixed',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.2)',
            top: 0,
            left: 0,
          }}
        />
      );
    return null;
  }),
  _buildMonth: setValue(function (
    monthIndex,
    direction,
    timeZone,
    languageName,
  ) {
    const months = [],
      date = Utility.generateDate(
        monthIndex,
        direction,
        timeZone,
        languageName,
      );
    let monthdays = [];
    while (true) {
      monthdays.push(Utility.createDayObject(date, timeZone));
      if (Utility.checkMonthEnd(date, direction, languageName)) {
        const month =
          languageName !== 'fa'
            ? Utility.createGregorianMonth(monthdays)
            : Utility.createShamsiMonth(monthdays);
        months.push(month);
        monthdays = [];
        break;
      }
    }
    return months;
  }),
  generateDate: setValue(function (
    monthIndex,
    direction,
    timeZone,
    languageName,
  ) {
    let date = new Date(
      new Date().toLocaleString(undefined, { timeZone: 'Asia/Tehran' }),
    );
    if (languageName === 'fa') {
      date.setDate(
        date.getDate() -
          momentjs(date.toLocaleDateString(), DATE_FORMAT_MOMENT).format(
            'jDD',
          ) +
          1,
      );
      let jDate = momentjs(date.toLocaleDateString(), DATE_FORMAT_MOMENT);
      jDate.add(monthIndex, 'jMonth');
      date = new Date(jDate.format(DATE_FORMAT_MOMENT));
    } else {
      date.setDate(1);
      date.setMonth(date.getMonth() + monthIndex);
    }
    date.setHours(0, 0, 0, 0);
    return date;
  }),

  createDayObject: setValue(function (date, timeZone) {
    date = new Date(date);
    return {
      miladi: Utility.createMiladiDate(date),
      shamsi: Utility.createShamsiDate(date),
      hijri: Utility.createHijriDate(date),
      isToday: Utility.createIsToday(date, timeZone),
      date,
    };
  }),

  createMiladiDate: setValue(function (date) {
    const tempDate = date.toLocaleDateString().split('/');
    tempDate.unshift(tempDate.pop());
    //add padStart for add 0 for day or month less than 10
    return tempDate.map((date) => date.padStart(2, '0'));
  }),

  createShamsiDate: setValue(function (date) {
    return momentjs(date.toLocaleDateString(), DATE_FORMAT_MOMENT)
      .format('jYYYY-jMM-jDD')
      .split('-');
  }),

  createHijriDate: setValue(function (date) {
    return moment(date).subtract(1, 'day').format('iYYYY-iMM-iDD').split('-');
  }),
  createIsToday: setValue(function (date, timeZone) {
    return (
      date.toLocaleDateString() === new Date().toLocaleDateString()
      // new Date().toLocaleDateString(undefined, { timeZone })
    );
  }),

  returnToday: setValue(function (timeZone) {
    // const today = new Date().toLocaleDateString(undefined, { timeZone });
    const today = new Date().toLocaleDateString();

    return Utility.createDayObject(today, timeZone);
  }),

  checkMonthEnd: setValue(function (date, direction, languageName) {
    if (
      languageName !== 'fa' &&
      date.getMonth() !== date._addDays(1).getMonth()
    )
      return true;
    else if (
      languageName === 'fa' &&
      momentjs(date.toLocaleDateString(), DATE_FORMAT_MOMENT).format('jMM') !==
        momentjs(
          date._addDays(1).toLocaleDateString(),
          DATE_FORMAT_MOMENT,
        ).format('jMM')
    )
      return true;
    else return false;
  }),

  createShamsiMonth: setValue(function (monthdays) {
    const firstDay = monthdays[0].date;
    return {
      skipdays: Utility.setShamsiSkippDays(firstDay.getDay()),
      month: Utility.getShamsiMonth(firstDay),
      year: Utility.getShamsiYear(firstDay),
      days: monthdays,
    };
  }),

  createGregorianMonth: setValue(function (monthdays) {
    const firstDay = monthdays[0].date;
    return {
      skipdays: Utility.setGregorianSkippDays(firstDay.getDay()),
      month: Utility.getGregorianMonth(firstDay),
      year: Utility.getGregorianYear(firstDay),
      days: monthdays,
    };
  }),

  setShamsiSkippDays: setValue(function (skipDays) {
    return new Array((skipDays += 1)).fill(undefined);
  }),
  getShamsiMonth: setValue(function (date) {
    return parseInt(
      momentjs(date.toLocaleDateString(), DATE_FORMAT_MOMENT).format('jMM'),
    );
  }),
  getShamsiYear: setValue(function (date) {
    return parseInt(
      momentjs(date.toLocaleDateString(), DATE_FORMAT_MOMENT).format('jYYYY'),
    );
  }),

  setGregorianSkippDays: setValue(function (skipDays) {
    return new Array(skipDays).fill(undefined);
  }),

  getGregorianMonth: setValue(function (date) {
    return date.getMonth() + 1;
  }),

  getGregorianYear: setValue(function (date) {
    return date.getFullYear();
  }),

  currentDate: setValue(function (
    monthIndex,
    direction,
    timeZone,
    languageName,
  ) {
    const tempDate = Utility.generateDate(
      monthIndex,
      direction,
      timeZone,
      languageName,
    );
    if (languageName !== 'fa')
      return {
        month: Utility.getGregorianMonth(tempDate),
        year: Utility.getGregorianYear(tempDate),
      };
    else
      return {
        month: Utility.getShamsiMonth(tempDate),
        year: Utility.getShamsiYear(tempDate),
      };
  }),

  fillYearList: setValue(function (yearIndex, currentYear) {
    return new Array(12)
      .fill(currentYear + yearIndex)
      .map((year, i) => year + i - 5);
  }),

  monthDiff: setValue(function (date, endDate) {
    const end = momentjs(endDate || new Date()), //todays date
      now = momentjs(date), // another date
      duration = momentjs.duration(now.diff(end));
    return Math.round(duration.asMonths());
  }),

  checkDateDisabled: setValue(function (currentDate, disableBeforeDate) {
    if (disableBeforeDate) {
      disableBeforeDate = new Date(disableBeforeDate);
      disableBeforeDate.setHours(0, 0, 0, 0);
      if (currentDate < disableBeforeDate) return true;
    }
    return false;
  }),

  isDayOff: setValue(function (date, languageName, holiday) {
    if (languageName !== 'fa') {
      if (date.getDay() == 0) return true;
    } else if (date.getDay() == 5) return true;
    else if (holiday && holiday.isOff) return true;
    else return false;
  }),

  createAltDateObject: setValue(function (type, isDarkMode) {
    const className = `col alternative-date d-flex p-0 m-0 font-smaller justify-content-center ${
      isDarkMode ? 'text-secondary-dark' : ''
    }`;
    if (type === 'miladi')
      return {
        direction: 'ltr',
        fontFamily: 'GothamLight',
        className: className + ' font-weight-bold',
        abbr: true,
      };
    return {
      direction: 'rtl',
      fontFamily: 'Vazir',
      className,
      abbr: false,
    };
  }),

  setDayClass: setValue(function (
    isToday,
    isSelected,
    isDisabled,
    isDayOff,
    isDarkMode = false,
  ) {
    let className = '';

    if (isToday) className += isDarkMode ? ' text-greenish-blue' : ' today';
    if (isDayOff) className += ' text-danger';
    if (isSelected) className += isDarkMode ? ' selectedDark ' : ' selected';
    if (isDisabled) className += ' disable-day';
    if (isDarkMode && !isToday && !isDisabled && !isDayOff)
      className += 'text-third-dark-lighter';

    return className;
  }),

  fetchMonthHoliday: setValue(function (month, languageName) {
    let year = new Date().getFullYear();
    return new Promise(function (resolve, reject) {
      const culture = languageName === 'fa' ? 'IR' : 'US',
        holidayList =
          JSON.parse(sessionStorage.getItem(`holidayList-${culture}`)) || {};
      if (holidayList[`month-${month}`])
        resolve({ month, holidays: holidayList[`month-${month}`] });
      else
        calendarEventApi
          .getCalandarEventByCountry({
            countryAbr: culture,
            month,
            dateType: culture === 'IR' ? 'shamsi' : 'miladi',
          })
          .then((result) => {
            holidayList[`month-${month}`] = result;
            if (result.length)
              sessionStorage.setItem(
                `holidayList-${culture}`,
                JSON.stringify(holidayList),
              );
            resolve({ month, holidays: holidayList[`month-${month}`] });
          })
          .catch((err) => {
            reject(err, month);
          });
    });
  }),
});

export { Utility };
